function Customer(customer) {
  if (customer) {
    this.id = customer.id;
    this.name = customer.name;
    this.firstName = customer.first_name;
    this.lastName = customer.last_name;
    this.street = customer.street;
    this.city = customer.city;
    this.zipcode = customer.zipcode;
    this.ico = customer.ico;
    this.dic = customer.dic;
    this.phone = customer.phone;
    this.email = customer.email;
  } else {
    this.id = null;
    this.name = "";
    this.firstName = "";
    this.lastName = "";
    this.street = "";
    this.city = "";
    this.zipcode = "";
    this.ico = "";
    this.dic = "";
    this.phone = "";
    this.email = "";
  }
}

export default Customer;